import { render, staticRenderFns } from "./university.vue?vue&type=template&id=4aa4cd0e&scoped=true&"
import script from "./university.vue?vue&type=script&lang=js&"
export * from "./university.vue?vue&type=script&lang=js&"
import style0 from "./university.vue?vue&type=style&index=0&id=4aa4cd0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa4cd0e",
  null
  
)

export default component.exports